import React, { useEffect, useState } from "react";
import api from '../../../config/axiosConfig';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Table from 'react-bootstrap/Table';
import logo from '../../../assets/Navbar/logo.png';
import loaderGif from "../../../assets/loader.gif";

const Bookings = () => {
  const today = new Date();
  const [formData, setFormData] = useState({
    numberOfAdults: 0,
    accountid: '',
    checkIn: new Date(today.setDate(today.getDate() + 1)),
    checkOut: new Date(today.setDate(today.getDate() + 1)),
    residentialsSelected: [],
    days: '',
    isactive: true,
    total: '',
    discount: 0,
    discountedAmount: '',
    advancedPayment: '',
    numberOfKids:0,
    accountname:'',
    accountEmail:'',
    sentMail: true,
    bookingTypeId: 1
  });
  const [accounts, setAccounts] = useState([]);
  const [residentials, setResidentials] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedResidences, setSelectedResidences] = useState([]);
  const [extraGuestsCount, setExtraGuestsCount] = useState({}); // { residentialId: extraGuestCount }
  const [data, setData] = useState({});
  const [isEdited, setIsEdited] = useState(false);
  const [loader, setLoader] = useState(false);
  const [bookingType, setBookingType] = useState([]);
  // let [selectedBookingTypeId, setSelectedBookingTypeId] = useState(null); //For displaying item list by default
  const [bookingTypeId, setBookingTypeId] = useState(null);


  const getData = async () => {
    try {
      const bookingResponse = await api.get("/accounts");
      setAccounts(bookingResponse.data);

      const residentailsResponse = await api.get("/residential");
      setResidentials(residentailsResponse.data);

      const bookingTypes = await api.get("/bookingTypes")
      setBookingType(bookingTypes.data);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData()
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));

  };

  const normalizeDate = (date) => {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0); // Set time to 00:00:00
    return normalized;
  };

  // Calculate Capacity and Pricing
  useEffect(() => {
    const fetchBookingDetails = async () => {
      if (!formData.checkIn || !formData.checkOut || !formData.residentialsSelected.length || !formData.numberOfAdults) return;
      let selectedResidentials = residentials.filter(res => formData.residentialsSelected.includes(res.id.toString()));
      setSelectedResidences(selectedResidentials);

      try {
        const bookingResponse = await api({
          method: 'POST',
          url: '/bookings/detailsforbooking',
          data: {
            accountid: formData.accountid,
            checkIn: formData.checkIn,
            checkOut: formData.checkOut,
            residentialid: formData.residentialsSelected,
            extraGuests:extraGuestsCount
          }
        })
        setData(bookingResponse.data.rows)
        setFormData({ ...formData, days: bookingResponse.data.days, accountname: bookingResponse.data.accountname, accountEmail: bookingResponse.data.accountEmail })
      } catch (error) {
        console.error("Error fetching booking details:", error);
      }
    };
  
    fetchBookingDetails();
  }, [formData.checkIn, formData.checkOut, formData.residentialsSelected, formData.numberOfAdults, extraGuestsCount]);

  const handleAddData = async (e) => {
    e.preventDefault();
    if (formData.accountid) {
      setLoader(true)
      try {
        const url = isEditMode ? `/bookings/${formData.id}` : '/bookings';
        const method = isEditMode ? 'put' : 'post';

        const bookingResponse = await api({
          method,
          url,
          data: {
            accountId: formData.accountid,
            checkInDate: formData.checkIn,
            checkOutDate: formData.checkOut,
            days: formData.days,
            total: formData.total,
            discount: formData.discount,
            advancedPayment: formData.advancedPayment,
            numberOfAdults: formData.numberOfAdults,
            numberOfKids: formData.numberOfKids,
            accountname: formData.accountname,
            accountEmail: formData.accountEmail,
            data:data,
            isactive: formData.isactive,
            sentMail: formData.sentMail,
            bookingTypeId: formData.bookingTypeId,
          }
        })

        if (bookingResponse && bookingResponse.status === 201) {

          await api({
            method: 'POST',
            url: '/residential/bookresidential',
            data: {
              lineItems: data,
              bookingId: bookingResponse.data
            }
          })

        }
        setFormData({ numberOfAdults: 0 });
        setData({})
        setLoader(false)
      } catch (error) {
        console.error('Error:', error);
      }

      setIsEditMode(false);
    } else {
      alert("Please fill out the name field.");
    }
  };

  const handleResidentialChange = (e) => {
    const { value, checked } = e.target;
    setFormData(prev => {
      const selected = new Set(prev.residentialsSelected);
      if (checked) {
        selected.add(value);
      } else {
        selected.delete(value);
      }
      return { ...prev, residentialsSelected: Array.from(selected) };
    });
  };

  useEffect(() => {
    if(data.length > 0){
    const totalAmount = 
        data.reduce((total, item) => total + (item.dailyPriceStandard || 0), 0) + 
        data.reduce((total, item) => total + (item.extraPersonDailyRate || 0), 0);
    
    const discounted = totalAmount - (formData?.discount || 0);
    const advance = discounted * 0.5;


    // if (!isEdited) {
      setFormData({ ...formData, total: totalAmount, discountedAmount:discounted, advancedPayment: advance })
    // }
  }
}, [data, formData]);
  
const handleAdvancedPaymentChange = (e) => {
  setFormData({ ...formData, advancedPayment: e.target.value});
  setIsEdited(true);
};

const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

const handleTypeChange = (e) => {
  const bookingTypeId = parseInt(e.target.value);
  const selectedType = bookingType.find(t => t.id === bookingTypeId)?.name;

  // setBookingTypeId(bookingTypeId);
  setFormData(prevFormData => ({
    ...prevFormData,
    bookingTypeId
  }));
};




  return (
    <Container fluid>
     <Row className="p-3">
        <Col md = {6}>
        <Row className="mt-4 border shadow p-4">
        <Col md={12}>
          <h5 className="text-start">Booking</h5>
          <Form >
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Account</Form.Label>
                  <InputGroup>
                    <Form.Select
                      name="accountid"
                      value={formData.accountid}  // This will hold the selected item type ID
                      onChange={handleChange} // Handle item type change
                    >
                      <option value="">Select Account</option>
                      {accounts && accounts.map((account) => (
                        <option key={account.id} value={account.id}>
                          {account.name}
                        </option>
                      ))}
                    </Form.Select>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="me-3">Number of Adults</Form.Label>
                  <Form.Control
                    type="number"
                    name="numberOfAdults"
                    placeholder="Enter Number of Guest"
                    value={formData.numberOfAdults}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="me-3">Number of Kids</Form.Label>
                  <Form.Text>(Age &lt; 7)</Form.Text>
                  <Form.Control
                    type="number"
                    name="numberOfKids"
                    placeholder="Enter Number of Kids"
                    value={formData.numberOfKids}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col sm={6} >
                <Form.Label>Check-in</Form.Label>
                <InputGroup>
                  <DatePicker
                    selected={formData.checkIn}
                    onChange={(date) => setFormData({ ...formData, checkIn:date })}
                    dateFormat="MMMM dd yyyy"
                    className="form-control"
                  />
                </InputGroup>
              </Col>
              <Col sm={6} >
                <Form.Label>Check-out</Form.Label>
                <InputGroup>
                  <DatePicker
                    selected={formData.checkOut}
                    onChange={(date) => setFormData({ ...formData, checkOut:date })}
                    dateFormat="MMMM dd yyyy"
                    className="form-control"
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Select Residential</Form.Label>
                  {residentials.map(res => (
                    <Form.Check
                      key={res.id}
                      type="checkbox"
                      label={res.name}
                      value={res.id}
                      checked={formData.residentialsSelected.includes(res.id.toString())}
                      onChange={handleResidentialChange}
                    />
                  ))}
                </Form.Group>
              </Col>
              <Col md={6}>
                {formData.numberOfAdults > 0 ? (
                  <>
                    <h4>Guest Accommodation Details</h4>
                    <ul>
                      {selectedResidences.length > 0 && selectedResidences.map((residential, index) => {
                        const standardGuests = Math.min(residential.standardOccupancy, formData.numberOfAdults);
                        const maxExtraGuests = residential.extraBedCapacity;

                        return (
                          <li key={residential.id}>
                            <strong>{residential.name}:</strong>
                            {standardGuests} guests in standard occupancy
                            +
                            <input
                              type="number"
                              min="0"
                              max={maxExtraGuests}
                              value={extraGuestsCount[residential.id] || 0}
                              onChange={(e) => {
                                let value = Math.min(maxExtraGuests, Math.max(0, Number(e.target.value)));
                                setExtraGuestsCount(prev => ({ ...prev, [residential.id]: value }));
                              }}
                              style={{ width: "100px", marginLeft: "10px" }}
                            /> extra guests
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : (
                  <p>Please select residentials and enter the total number of guests.</p>
                )}
              </Col>
            </Row>
            <Row className="mb-4">
              <Col sm={6} >
              <Form.Group>
                  <Form.Label className="me-3">Enter Discount</Form.Label>
                  <Form.Control
                    type="number"
                    name="discount"
                    placeholder="Enter discount"
                    value={formData.discount}
                    onChange={handleChange}
                    required
                  />
              </Form.Group>
              </Col>
              <Col sm={6} >
              <Form.Group>
                  <Form.Label className="me-3">Send Mail Status</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="sentMail"
                    label="Sent Mail"
                    checked={formData.sentMail}
                    onChange={handleChange}
                    className="ms-4"
                  />
              </Form.Group>
              </Col>
              
            </Row>
            <Row className="mb-4">
            <Col md={6}>
            <Form.Label className="me-3">Booking Type</Form.Label>
            <select
              className="form-control"
              value={formData.bookingTypeId ?? ""}
              onChange={(e) => {
                const selectedId = e.target.value ? parseInt(e.target.value) : null;
                setBookingTypeId(selectedId); // optional, if still needed
                setFormData(prev => ({ ...prev, bookingTypeId: selectedId }));
              }}
            >
              <option value="">Select Booking Type</option>
              {bookingType.map((type) => (
                <option key={type.id} value={type.id}>
                  {type.name}
                </option>
              ))}
            </select>
            </Col>
            </Row>
            <Button variant="primary" type="submit" onClick={handleAddData}>
              Book
            </Button>
          </Form>
        </Col>
      </Row>
        </Col>
        <Col md = {6}>
        <div className="border-1">
         <div className="mx-auto w-100">
         <img src={logo} alt="logo" className="img-fluid" style={{height:"40px"}}/>
         <div className="p-3">
            <div>
            {/* <span>Booking Reference:</span> <span>20250206-11</span> */}
            </div>
            <div>
            <span>Name:</span> <span>{formData.accountname}</span>
            </div>
            <div>
            <span>Check-in (1pm or later):</span> <span>{formatDate(formData.checkIn)}</span>

            </div>
            <div>
            <span>Check-out (by 11am):</span> <span>{formatDate(formData.checkOut)}</span>
            </div>
         </div>
         <div>
            <table className="table table-bordered">
                <thead>
                    <tr>
                        <th>
                        Date
                        </th>
                        <th>
                        Accomodation Residence Selected
                        </th>
                        <th>
                        Standard Occupancy
                        </th>
                        <th>
                        Rate
                        </th>
                        <th>
                        Rate Per Guest/Day
                        </th>
                        <th>
                        Extra Bed Rate
                        </th>
                        <th>
                        Rate Factor
                        </th>
                    </tr>
                </thead>
                {data.length > 0 ? (
                  <>
                        <tbody>
                            {data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.date}</td>
                                <td>{item.accomodationResidenceSelected}</td>
                                <td>{item.standardOccupancy}</td>
                                <td>{item.dailyPriceStandard}</td>
                                <td>{item.rate_per_guest_day}</td>
                                <td>{item.extraPersonDailyRate}</td>
                                <td>{item.rateFactor}</td>
                            </tr>
                            ))}
                            <tr style={{ fontWeight: "bold", backgroundColor: "#f2f2f2" }}>
                              <td colSpan="3">Total</td>
                              <td>
                                  {data.reduce((total, item) => total + (item.dailyPriceStandard || 0), 0)}
                              </td>
                              <td>
                                  -
                              </td>
                              <td>
                                  {data.reduce((total, item) => total + (item.extraPersonDailyRate || 0), 0)}
                              </td>
                              <td>-</td>
                          </tr>
                        </tbody>
                        
                        <div>
                            <div style={{ width: "300px" }}>{`Total - ${formData.total}`}</div>
                            <div style={{ width: "300px" }}>{`Discounted Amount - ${formData.discountedAmount}`}</div>
                            {/* <div style={{ width: "300px" }}>{`Advanced Payment - ${formData.advancedPayment}`}</div> */}
                            <div style={{ width: "300px" }}>
                            <label>Advanced Payment - </label>
                            <input 
                                type="number" 
                                value={formData.advancedPayment} 
                                onChange={handleAdvancedPaymentChange} 
                                style={{ width: "100px", marginLeft: "5px" }} 
                            />
                      </div>
                        </div>
                        </>
                        ) : (
                        <tbody>
                            <tr><td colSpan="7">Loading data...</td></tr>
                        </tbody>
                        )}
            </table>
         </div>
         </div>

        </div>
        </Col>
     </Row>
     <Row className="mt-4 border shadow p-4">
          {loader && (
                <div className="loader-overlay">
                    <img src={loaderGif} alt="Loading..." className="loader" />
                </div>
              )}
      </Row>
    </Container>
  )

}

export default Bookings;